import { useState, useEffect, useRef } from 'react';
import { GetRequest } from 'components/common';

// The printing colours the owner can price on the carton material the visitor chose, fetched again on every material
// change. null until the chosen material's answer arrives -- an answer for a material the visitor has since left is
// dropped, so the choices never belong to another material -- and on a failed fetch, when the form posts no colours
// and the quote is made on the Printing form's own CMYK (QuoteBuilderWidget::SubmitQuoteService).
const usePrintingColorChoices = (widgetIdentifier, cartonMaterialUserPriceId) => {
  const [printingColors, setPrintingColors] = useState(null);
  const requestedMaterialIdRef = useRef(null);

  const fetchPrintingColors = () => {
    requestedMaterialIdRef.current = cartonMaterialUserPriceId;
    setPrintingColors(null);
    if (!widgetIdentifier || !cartonMaterialUserPriceId) {
      return;
    }
    GetRequest({
      url: `/widget/quote-builder/${widgetIdentifier}/printing-colors?carton_material_user_price_id=${cartonMaterialUserPriceId}`,
      callback: (data) => {
        if (requestedMaterialIdRef.current !== cartonMaterialUserPriceId) { return; }
        setPrintingColors({ choices: data.choices, defaultChoice: data.default_choice });
      }
    });
  };

  useEffect(fetchPrintingColors, [widgetIdentifier, cartonMaterialUserPriceId]);

  return printingColors;
};

export default usePrintingColorChoices;
